import PartnerSlider from "../blocks/partner-slider";

const templateAbout = {
  init() {
    new PartnerSlider(".partners");
    templateAbout.videoAnimation();
  },

  videoAnimation() {
    $(".production__video").click(function() {
      var video = $(this).find("video")[0];
      if (video.paused) {
          $(this).addClass('playing');
          video.play();
      } else {
          $(this).removeClass('playing');
          video.pause();
      }
    });
  },

};

export default templateAbout;
